import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/Context";
import DoneIcon from "@mui/icons-material/Done";
import axios from "axios";
import cancelIcon from "../../picture/cancel.png";
import resetIcon from "../../../picture/timer-language.png";
import ConfirmationModal from "../FolderDocument/ConfirmationModal";
import WarningModal from "../Documents/WarningModal";

const ShowBarContent = ({
  title,
  list,
  listArchive,
  maxList,
  setSelectedItems,
  companyId
}) => {
  const [showingLocation, setShowingLocation] = useState(false);
  const [archiveClicked, setArchiveClicked] = useState(false);
  const [adding, setAdding] = useState(false);
  const [newData, setNewData] = useState(""); // To store the entered email
  const [errorMessage, setErrorMessage] = useState(""); // For errors
  const [successMessage, setSuccessMessage] = useState(""); // For success messages
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [deleteId, setDeleteId] = useState("");
  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);

  const [selected, setSelected] = useState(true);

  const { dictionary, setCurrentName, setChooseObject, setSelectedSettings } =
    useGlobalContext();

  const handleShowMore = () => {
    setShowingLocation(!showingLocation);
  };

  const checkLength = () => {
    return list.length >= maxList;
  };

  const clickAdd = (cond) => {
    if (cond) {
      alert("Ne može se dodati novi objekat tipa " + title);
    } else {
      setAdding(true);
      setErrorMessage("");
      setSuccessMessage("");
    }
  };

  const handleAdd = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    if (title === "LOKACIJE") {
      try {
        const response = await axios.post(
          "https://data.nadzor.app/api/locations/create.php",
          {
            company_id: companyId,
            location_name: newData
          }
        );
        const { location_id } = response.data;

        setCurrentName(newData);
        setAdding(false);
        setNewData("");
        // setSelectedItem({
        //   locations: title === "LOKACIJE",
        //   users: title === "KORISNICI"
        // });
        setSelectedItems((prev) => ({
          ...prev,
          locations: [
            ...prev.locations,
            { name: newData, location_id, highlight: true }
          ]
        }));

        // setChooseObject({
        //   currentIndex: selectedAccount
        //     ? (selectedAccount.locations || []).length
        //     : (selectedCompany.locations || []).length,
        //   data: newData,
        //   id: parseInt(location_id),
        //   index: 3
        // });
        setSelectedSettings(1);

        setTimeout(
          () =>
            setSelectedItems((prev) => ({
              ...prev,
              locations: prev.locations.map((loc) => ({
                ...loc,
                highlight: false
              }))
            })),
          2000
        );
      } catch (err) {
        console.log(err);
        setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
      }
      return;
    }

    // New functionality: Check and add user by email
    try {
      // Check if the user exists
      const checkResponse = await axios.post(
        "https://data.nadzor.app/api/admin_panel/user_company/checkIfUserExists.php",
        { email: newData }
      );

      if (checkResponse.data.status === 200) {
        const userId = checkResponse.data.user.id;

        // Add user to the company
        const addResponse = await axios.post(
          "https://data.nadzor.app/api/users/create.php",
          {
            user_id: userId,
            company_id: companyId
          }
        );

        if (addResponse.data.status === 201) {
          // setSuccessMessage("Korisnik uspešno dodat.");
          setAdding(false);
          setNewData("");
          // setCurrentTab("KEY");
          // setIsNewUserAdded(true);

          setSelectedItems((prev) => ({
            ...prev,
            users: [
              ...prev.users,
              {
                name: newData,
                user_id: userId,
                highlight: true,
                predstavnik: addResponse.data.predstavnik
              }
            ]
          }));

          setTimeout(
            () =>
              setSelectedItems((prev) => ({
                ...prev,
                users: prev.users.map((user) => ({
                  ...user,
                  highlight: false
                }))
              })),
            2000
          );

          // setTimeout(() => setIsNewUserAdded(false), 2000);
        } else {
          setErrorMessage("Greška prilikom dodavanja korisnika.");
        }
      } else if (checkResponse.data.status === 404) {
        setIsValidEmail(false);
        setErrorMessage("Korisnik sa ovom email adresom ne postoji.");
      } else {
        setErrorMessage("Greška prilikom provere korisnika.");
      }
    } catch (error) {
      console.log(error);
      setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
    }
  };

  const toggleArchive = async (item, arch) => {
    if (title === "LOKACIJE") {
      try {
        await axios.post(
          "https://data.nadzor.app/api/locations/toggle_status.php",
          { location_id: item.location_id }
        );
        arch
          ? setSelectedItems((prev) => ({
              ...prev,
              archived_locations: [...prev.archived_locations, item],
              locations: prev.locations.filter(
                (loc) => loc.location_id != item.location_id
              )
            }))
          : setSelectedItems((prev) => ({
              ...prev,
              archived_locations: prev.archived_locations.filter(
                (loc) => loc.location_id != item.location_id
              ),
              locations: [...prev.locations, item]
            }));
      } catch (err) {
        setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
      }
      return;
    }

    try {
      await axios.post("https://data.nadzor.app/api/users/toggle_status.php", {
        user_id: item.user_id,
        company_id: companyId
      });

      arch
        ? setSelectedItems((prev) => ({
            ...prev,
            archived_users: [...prev.archived_users, item],
            users: prev.users.filter((user) => user.user_id != item.user_id)
          }))
        : setSelectedItems((prev) => ({
            ...prev,
            archived_users: prev.archived_users.filter(
              (user) => user.user_id != item.user_id
            ),
            users: [...prev.users, item]
          }));
    } catch (err) {
      setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
    }
  };

  const deleteArchive = (item) => {
    setDeleteId(title === "LOKACIJE" ? item.location_id : item.user_id);
  };

  const handleCloseDelete = () => {
    setDeleteId("");
  };

  const handleConfirmDelete = async () => {
    if (title === "LOKACIJE") {
      try {
        const res = await axios.post(
          "https://data.nadzor.app/api/locations/delete_location.php",
          { location_id: deleteId }
        );
        const { status, message } = res.data;
        if (status !== 409) {
          setSelectedItems((prev) => ({
            ...prev,
            archived_locations: prev.archived_locations.filter(
              (loc) => loc.location_id != deleteId
            )
          }));
        }
        if (status === 409 && message === "BRISANJE_NIJE_DOZVOLJENO") {
          setIsOpenWarningModal(true);
        }
        handleCloseDelete();
      } catch (err) {
        setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
      }
      return;
    }

    try {
      const res = await axios.post(
        "https://data.nadzor.app/api/users/remove_user_from_company.php",
        {
          user_id: deleteId,
          company_id: companyId
        }
      );
      const { status, message } = res.data;
      if (status !== 409) {
        setSelectedItems((prev) => ({
          ...prev,
          archived_users: prev.archived_users.filter(
            (user) => user.user_id != deleteId
          )
        }));
      }
      if (status === 409 && message === "BRISANJE_NIJE_DOZVOLJENO") {
        setIsOpenWarningModal(true);
      }
    } catch (err) {
      setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
    }
    handleCloseDelete();
  };

  const handleCancel = (e) => {
    const div = document.querySelector(`.add-input-div.${title}`);
    if (div) {
      const isInside = div.contains(e.target);
      if (!isInside) {
        setAdding(false);
      }
    }
  };

  const handleCancelWarningModal = () => {
    setIsOpenWarningModal(false);
  };

  return (
    <div className="user-location">
      <div
        className="user-location-row title"
        onClick={() => setSelected(!selected)}
      >
        {selected && <div className="netting-div-title"></div>}
        <span className="button-span">
          <span>{selected ? "-" : "+"}</span>
        </span>
        <span className="user-location-label">{title}</span>
      </div>
      {selected &&
        list.slice(0, 5).map((company, indexLocation) => {
          return (
            <div key={indexLocation} className="data">
              <div className="netting-div"></div>
              <div
                className="netting-div-side-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: "10px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="netting-div-side"></div>
                  <span
                    style={{ color: company.highlight ? "#00b055ff" : "black" }}
                  >
                    {company.name || company.email}
                  </span>
                </div>
                <div
                  onClick={() => toggleArchive(company, true)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={cancelIcon}
                    style={{ width: "10px", height: "10px" }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      {showingLocation &&
        selected &&
        list.slice(5, list.length).map((company, indexLocation) => {
          return (
            <div key={indexLocation} className="data">
              <div className="netting-div"></div>
              <div
                className="netting-div-side-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: "10px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="netting-div-side"></div>
                  <span
                    style={{ color: company.highlight ? "#00b055ff" : "black" }}
                  >
                    {company.name || company.email}
                  </span>
                </div>
                <div
                  onClick={() => toggleArchive(company, true)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={cancelIcon}
                    style={{ width: "10px", height: "10px" }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      {list.length > 5 && selected && (
        <div
          className="user-location-row more"
          onClick={() => handleShowMore()}
        >
          <div className="netting-div"></div>
          <div className="netting-div-side-container">
            <div className="netting-div-side"></div>
            <span>{showingLocation ? "...less" : "...more"}</span>
          </div>
        </div>
      )}
      {selected && (
        <>
          {!adding ? (
            <div
              className="user-location-row add"
              style={{ color: `${checkLength() ? "red" : "green"}` }}
              onClick={() => clickAdd(checkLength())}
            >
              <div className="netting-div"></div>
              <div className="netting-div-side-container">
                <div className="netting-div-side"></div>
                DODAJ +
              </div>
            </div>
          ) : (
            <div style={{ fontSize: "2vh" }} className={`add-input-div ${title}`} onClick={handleCancel}>
              <input
                value={newData}
                onChange={(e) => {
                  setIsValidEmail(true);
                  setNewData(e.target.value);
                  setErrorMessage("");
                }}
                style={{ color: isValidEmail ? "black" : "red" }}
                placeholder={
                  title === "LOKACIJE"
                    ? "Unesite naziv lokacija"
                    : "Unesite email adresu"
                }
              />
              {newData !== "" && isValidEmail && (
                <DoneIcon className="icon" onClick={handleAdd}></DoneIcon>
              )}
            </div>
          )}
        </>
      )}
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {successMessage && <p className="success-message">{successMessage}</p>}
      {selected && (
        <div className="user-location-archive">
          <div
            onClick={() => setArchiveClicked(!archiveClicked)}
            className="archive-title"
          >
            ARHIVA {archiveClicked ? "-" : "+"}
          </div>
          {archiveClicked &&
            listArchive.map((item, index) => {
              return (
                <div
                  className="data-archive"
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "10px"
                  }}
                >
                  <div className="netting-div-archive"></div>
                  <span key={index} className="archive-name">
                    {item.name || item.email}
                  </span>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <div
                      onClick={() => toggleArchive(item, false)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={resetIcon}
                        style={{ width: "12px", height: "12px" }}
                      />
                    </div>
                    <div
                      onClick={() => deleteArchive(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={cancelIcon}
                        style={{ width: "10px", height: "10px" }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {deleteId && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={
            title === "LOKACIJE"
              ? dictionary["deleteLokacija"]
              : dictionary["deleteKorisnik"]
          }
          handleCancel={handleCloseDelete}
        />
      )}
      {isOpenWarningModal && (
        <WarningModal
          text={dictionary["brisanjeNijeDozvoljeno"]}
          handleCancel={handleCancelWarningModal}
        />
      )}
    </div>
  );
};

export default ShowBarContent;
